import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBarIcons from './TopBarIcons';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';




const ChangePassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false); 
  const theUserType = localStorage.getItem('userType');
  const theUserId = localStorage.getItem('userId'); 
   



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  // Clear previous messages
  setErrorMessage('');
  setSuccessMessage('');

  // Validation
  if (formData.newPassword !== formData.confirmPassword) {
    setErrorMessage('The password that you have written in the "New password" field and "Confirm New Password" is not the same.');
    return;
  }

  // Password strength validation (optional but recommended)
  if (formData.newPassword.length < 8) {
    setErrorMessage('New password must be at least 8 characters long.');
    return;
  }

setIsLoading(true);

  try {
    console.log('Sending request to:', `${process.env.REACT_APP_API_BASE_URL}/user/${theUserId}/change-password`);
    console.log('token', localStorage.getItem('token'));
    const response = await axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/users/${theUserId}/change-password`,
      {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}` // Add if your API requires authentication
        },
        timeout: 10000, // 10 second timeout
      }
    );

    if (response.status === 200) {
      setSuccessMessage('Your password has been changed successfully');
      setFormData({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      setTimeout(() => navigate('/login'), 2000);
    }
  } catch (error) {
    console.error('Password change error:', error);
    
    if (error.code === 'ECONNABORTED') {
      setErrorMessage('Error. Please check your connection and try again.');
      console.log('Request timeout. Please check your connection and try again.');
    } else if (error.response) {
      // Server responded with error status
      setErrorMessage(`Error`);
      console.log(error.response.data.message || `Error: ${error.response.status}`);
    } else if (error.request) {
      // Request was made but no response received
      setErrorMessage('Error. Please check your internet connection.');
    } else {
      // Something else happened
      setErrorMessage('Error. Please try again.');
      console.log("An unexpected error occurred. Please try again.");
    }
  }
  finally {
      setIsLoading(false); // Stop loading regardless of outcome
    }
  };

  return (
    <div id="wrapper">
      {/* Sidebar */}
      <Sidebar userType={theUserType} />

      {/* Content Wrapper */}

<div id="content-wrapper" className="d-flex flex-column">

{/* Main Content */}
<div id="content">
{/* Topbar */}
<nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

{/* Sidebar Toggle */}
<button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
    <i className="fa fa-bars"></i>
</button>

{/* Topbar Search */}
<form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
    <div className="input-group">
        <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
            aria-label="Search" aria-describedby="basic-addon2" />
        <div className="input-group-append">
            <button className="btn btn-primary" type="button">
                <i className="fas fa-search fa-sm"></i>
            </button>
        </div>
    </div>
</form>

{/* Topbar Navbar */}
<ul className="navbar-nav ml-auto">

    <TopBarIcons />
    
    

</ul>

</nav>
{/* End of Topbar */}
 {/* Begin Page Content */}
 <div className="container-fluid">
       
 <div className="view-requisition-header">
                 <Link className="nav-link" to="/settings">
                   <i className="fas fa-arrow-left back-button"></i> {/* Back */}
                 </Link>
                 <h1 className="form-heading h3 mb-4 text-gray-800">Settings</h1>
             </div>
 
 {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      {successMessage && <div className="alert alert-success">{successMessage}</div>}

      <div className="form-group reduce-width-div">
      <h3>Change Password</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="currentPassword">Current Password</label>
            <input
              type="password"
              id="currentPassword"
              name="currentPassword"
              className="form-control"
              value={formData.currentPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              className="form-control"
              value={formData.newPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              className="form-control"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary"  disabled={isLoading} >Change Password</button>
        </form>
      </div>
      </div>
        {/* End of container-fluid */}

  </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

    </div>


    
    </div>
  );
};

export default ChangePassword;
